import React from 'react';
import PageLayout from '../../components/PageLayout';
import HeadQuarter from '../../components/master/HeadQuarter';


interface MasterPageProps {
  onLogout?: () => void;
  currentPage?: string;
  onNavigate?: (page: string) => void;
}

const HeadQuarterPage: React.FC<MasterPageProps> = ({ onLogout, currentPage, onNavigate }) => {

  return (
    <PageLayout onLogout={onLogout} currentPage={currentPage} onNavigate={onNavigate}>
      <HeadQuarter />
    </PageLayout>
  );
};

export default HeadQuarterPage;
